import { pdf } from '@react-pdf/renderer'

// Generates a react-pdf document on demand and triggers a browser download.
// Deliberately NOT using <PDFDownloadLink> for documents whose content
// changes frequently (e.g. built from live form state) - PDFDownloadLink
// regenerates its blob reactively whenever the `document` prop's identity
// changes, and @react-pdf/renderer's internal layout engine throws
// ("X is not a function") if a new render starts while a previous one for
// the same link is still in flight. Building the document once, only when
// the user actually clicks, avoids that entirely.
export const downloadPdf = async (documentElement, fileName) => {
  const blob = await pdf(documentElement).toBlob()
  const url = URL.createObjectURL(blob)
  const link = window.document.createElement('a')
  link.href = url
  link.download = fileName
  window.document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
